import React from 'react'

const ContactUs = () => {
    return (
        <main className="max-w-[960px] mx-auto px-4 py-12 md:py-20 flex flex-col items-center">
            {/* Headline Section */}
            <div className="text-center mb-10 max-w-[600px]">
                <h1 className="text-[#0d1b15] dark:text-white tracking-tight text-4xl md:text-5xl font-bold leading-tight pb-4">
                    We’re here to help.
                </h1>
                <p className="text-[#0d1b15]/70 dark:text-slate-300 text-lg font-normal leading-relaxed">
                    Have a question about your lessons or the platform? Get in touch and our team
                    will respond as soon as possible.
                </p>
            </div>
            {/* Contact Form Card */}
            <div className="w-full max-w-[640px] bg-white dark:bg-background-dark/50 p-8 md:p-12 rounded-xl shadow-xl shadow-primary/5 border border-[#e7f3ee] dark:border-primary/10">
                <form action="#" className="space-y-6">
                    {/* Dual Field Row */}
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                        <div className="flex flex-col gap-2">
                            <label
                                className="text-sm font-semibold text-[#0d1b15] dark:text-slate-200"
                                htmlFor="full-name"
                            >
                                Full Name
                            </label>
                            <input
                                className="form-input w-full rounded-lg border border-[#cfe7dd] dark:border-primary/20 bg-[#f8fcfa] dark:bg-background-dark/30 text-[#0d1b15] dark:text-white focus:ring-2 focus:ring-primary focus:border-primary h-14 px-4 text-base placeholder:text-[#4c9a78]/60 transition-all"
                                id="full-name"
                                placeholder="John Doe"
                                type="text"
                            />
                        </div>
                        <div className="flex flex-col gap-2">
                            <label
                                className="text-sm font-semibold text-[#0d1b15] dark:text-slate-200"
                                htmlFor="email"
                            >
                                Email Address
                            </label>
                            <input
                                className="form-input w-full rounded-lg border border-[#cfe7dd] dark:border-primary/20 bg-[#f8fcfa] dark:bg-background-dark/30 text-[#0d1b15] dark:text-white focus:ring-2 focus:ring-primary focus:border-primary h-14 px-4 text-base placeholder:text-[#4c9a78]/60 transition-all"
                                id="email"
                                placeholder="john@example.com"
                                type="email"
                            />
                        </div>
                    </div>
                    {/* Message Field */}
                    <div className="flex flex-col gap-2">
                        <label
                            className="text-sm font-semibold text-[#0d1b15] dark:text-slate-200"
                            htmlFor="message"
                        >
                            How can we help?
                        </label>
                        <textarea
                            className="form-input w-full rounded-lg border border-[#cfe7dd] dark:border-primary/20 bg-[#f8fcfa] dark:bg-background-dark/30 text-[#0d1b15] dark:text-white focus:ring-2 focus:ring-primary focus:border-primary min-h-[160px] p-4 text-base placeholder:text-[#4c9a78]/60 transition-all"
                            id="message"
                            placeholder="Describe your issue or question here..."
                            defaultValue={""}
                        />
                    </div>
                    {/* Action Button */}
                    <div>
                        <button
                            className="w-full flex items-center justify-center gap-2 rounded-lg h-14 bg-primary text-white text-lg font-bold transition-all hover:bg-primary/90 shadow-md"
                            type="submit"
                        >
                            <span>Send Message</span>
                            <span className="material-symbols-outlined text-lg">send</span>
                        </button>
                    </div>
                </form>
                <div className="mt-8 pt-8 border-t border-[#e7f3ee] dark:border-primary/10 text-center">
                    <p className="text-sm text-[#0d1b15]/60 dark:text-slate-400">
                        Prefer email? Reach us directly at{" "}
                        <a
                            className="font-bold text-primary-link dark:text-emerald-400 hover:underline transition-all underline-offset-4"
                            href="mailto:support@tutormatchae.com"
                        >
                            support@tutormatchae.com
                        </a>
                    </p>
                </div>
            </div>
            {/* Trust Badges or Extra Info */}
            <div className="mt-16 flex flex-wrap justify-center gap-12 text-center text-[#0d1b15]/50 dark:text-slate-500">
                <div className="flex flex-col items-center gap-2">
                    <span className="material-symbols-outlined text-3xl text-primary/60">
                        verified_user
                    </span>
                    <span className="text-sm font-medium">Direct Communication</span>
                </div>
                <div className="flex flex-col items-center gap-2">
                    <span className="material-symbols-outlined text-3xl text-primary/60">
                        schedule
                    </span>
                    <span className="text-sm font-medium">Ongoing Support</span>
                </div>
                <div className="flex flex-col items-center gap-2">
                    <span className="material-symbols-outlined text-3xl text-primary/60">
                        group
                    </span>
                    <span className="text-sm font-medium">Support Team</span>
                </div>
            </div>
        </main>
    )
}

export default ContactUs;